module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"tr":{"cost-out-range":"Maksimum 9 basamaklı veri girişi yapabilirsiniz. Daha küçük sayılar ile giriş yapmayı deneyiniz.","value-out-range":"Maksimum 9 basamaklı veri girişi yapabilirsiniz. Daha küçük sayılar ile giriş yapmayı deneyiniz.","Evsel Atık":"Evsel Atık"},"en":{"cost-out-range":"You can enter a maximum of 9 digits. Try to enter smaller data.","value-out-range":"You can enter a maximum of 9 digits. Try to enter smaller data.","Evsel Atık":"Domestic Waste"}}')
}



//////////////////
// WEBPACK FOOTER
// ./node_modules/@kazupon/vue-i18n-loader/lib!./node_modules/vue-loader/lib/selector.js?type=customBlocks&index=1!./src/views/Data/Detail.vue
// module id = nQpw
// module chunks = 1